module.exports = __webpack_public_path__ + "static/media/infohub-mobile.2a9860d8.png";